module.exports = __webpack_public_path__ + "static/img/audio_text_robot.9a559c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audio_text_robot.png
// module id = aQ3w
// module chunks = 0